export const stakingRoute = [
  {
    path: ":id",
    name: "planDetail",
    meta: {
      transitionName: "slide"
    },
    component: () => import("@/views/panel/Staking/PlanDetailPage/index.vue")
  }
];
